// src/models/ContactPersonRole.interface.ts

export type ContactPersonRole = 
  | { role: 'owner'; displayName: 'Property Owner'; category: 'Individual' }
  | { role: 'real_estate_investor'; displayName: 'Real Estate Investor'; category: 'Individual' }
  | { role: 'tenant'; displayName: 'Tenant/Renter'; category: 'Individual' }
  
  // Association/Organization
  | { role: 'hoa_representative'; displayName: 'HOA Representative'; category: 'Association' }
  | { role: 'condo_board_member'; displayName: 'Condo Board Member'; category: 'Association' }
  
  // Professional Managers
  | { role: 'property_manager'; displayName: 'Property Manager'; category: 'Professional Manager' }
  | { role: 'facilities_manager'; displayName: 'Facilities Manager'; category: 'Professional Manager' }
  | { role: 'asset_manager'; displayName: 'Asset Manager'; category: 'Professional Manager' }
  
  // Real Estate Professionals
  | { role: 'real_estate_agent'; displayName: 'Real Estate Agent'; category: 'Real Estate Professional' }
  | { role: 'real_estate_broker'; displayName: 'Real Estate Broker'; category: 'Real Estate Professional' }
  
  // Builder/Developer
  | { role: 'developer'; displayName: 'Developer'; category: 'Developer/Builder' }
  
  // General Contractor
  | { role: 'remodeling_contractor'; displayName: 'Remodeling Contractor'; category: 'General Contractor' }
  | { role: 'custom_home_builder'; displayName: 'Custom Home Builder'; category: 'General Contractor' }
  | { role: 'spec_builder'; displayName: 'Spec Builder'; category: 'General Contractor' }
  | { role: 'design_build_contractor'; displayName: 'Design-Build Contractor'; category: 'General Contractor' }
  | { role: 'builder_rep'; displayName: 'Builder Representative'; category: 'General Contractor' }
  | { role: 'construction_manager'; displayName: 'Construction Manager'; category: 'General Contractor' };

// Sort CONTACT_PERSON_ROLES by category first, then by displayName
export const CONTACT_PERSON_ROLES: ContactPersonRole[] = [
  // Association/Organization
  { role: 'condo_board_member', displayName: 'Condo Board Member', category: 'Association' },
  { role: 'hoa_representative', displayName: 'HOA Representative', category: 'Association' },
  
  // Developer/Builder
  { role: 'developer', displayName: 'Developer', category: 'Developer/Builder' },
  
  // General Contractor
  { role: 'builder_rep', displayName: 'Builder Representative', category: 'General Contractor' },
  { role: 'construction_manager', displayName: 'Construction Manager', category: 'General Contractor' },
  { role: 'custom_home_builder', displayName: 'Custom Home Builder', category: 'General Contractor' },
  { role: 'design_build_contractor', displayName: 'Design-Build Contractor', category: 'General Contractor' },
  { role: 'remodeling_contractor', displayName: 'Remodeling Contractor', category: 'General Contractor' },
  { role: 'spec_builder', displayName: 'Spec Builder', category: 'General Contractor' },
  
  // Individual
  { role: 'owner', displayName: 'Property Owner', category: 'Individual' },
  { role: 'real_estate_investor', displayName: 'Real Estate Investor', category: 'Individual' },
  { role: 'tenant', displayName: 'Tenant/Renter', category: 'Individual' },
  
  // Professional Manager
  { role: 'asset_manager', displayName: 'Asset Manager', category: 'Professional Manager' },
  { role: 'facilities_manager', displayName: 'Facilities Manager', category: 'Professional Manager' },
  { role: 'property_manager', displayName: 'Property Manager', category: 'Professional Manager' },
  
  // Real Estate Professional
  { role: 'real_estate_agent', displayName: 'Real Estate Agent', category: 'Real Estate Professional' },
  { role: 'real_estate_broker', displayName: 'Real Estate Broker', category: 'Real Estate Professional' }
];

export const getContactPersonRoleByValue = (role: string): ContactPersonRole | undefined => {
  return CONTACT_PERSON_ROLES.find(r => r.role === role);
};

export const formatContactPersonRoleOption = (role: ContactPersonRole): string => {
  return `${role.category}: ${role.displayName}`;
};

export const getDefaultContactPersonRole = (): string => {
  return 'owner'; // This corresponds to "Individual: Property Owner"
};